import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-surface-950 text-surface-100 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="text-brand-400 hover:text-brand-300 text-sm mb-4 inline-block">
          ← На главную
        </Link>

        <h1 className="text-3xl font-bold mb-2">Пользовательское соглашение</h1>
        <p className="text-surface-400 text-sm mb-8">Последнее обновление: 16 апреля 2026</p>

        <section className="space-y-4 text-sm leading-relaxed">
          <h2 className="text-xl font-semibold mt-6">1. Принятие условий</h2>
          <p>
            Регистрируясь в сервисе swipa (далее — «Сервис»), расположенном по адресу
            swipa.ru, вы подтверждаете, что ознакомились с настоящим Пользовательским соглашением
            (далее — «Соглашение») и безоговорочно принимаете все его условия. Если вы не согласны
            с какими-либо положениями — не используйте Сервис и не регистрируйтесь.
          </p>

          <h2 className="text-xl font-semibold mt-6">2. Правила использования</h2>
          <p>Запрещается использовать Сервис для:</p>
          <ul className="list-disc list-inside space-y-1 text-surface-300">
            <li>Распространения противоправного контента</li>
            <li>Спама, рассылок и флуда</li>
            <li>Оскорблений других пользователей</li>
            <li>Публикации личных данных других лиц без их согласия</li>
            <li>Атак на сервис (DoS, brute-force и т.д.)</li>
            <li>Автоматизации (ботов) без разрешения администрации</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6">3. Имя пользователя и товарные знаки</h2>
          <p>
            Имя пользователя (логин) является идентификатором в Сервисе и не предоставляет
            никаких исключительных прав собственности. Администрация Сервиса оставляет за собой
            право в одностороннем порядке изменить или отозвать имя пользователя в следующих случаях:
          </p>
          <ul className="list-disc list-inside space-y-1 text-surface-300">
            <li>
              Имя пользователя совпадает с зарегистрированной торговой маркой, товарным знаком
              или знаком обслуживания, правообладателем которого является третье лицо
            </li>
            <li>
              Имя пользователя вводит других пользователей в заблуждение относительно
              принадлежности аккаунта к какой-либо организации, бренду, публичной персоне
              или государственному органу
            </li>
            <li>
              Правообладатель торговой марки направил обоснованную претензию администрации
              Сервиса в отношении данного имени пользователя
            </li>
            <li>
              Имя пользователя используется в целях мошенничества, фишинга или иных
              недобросовестных действий
            </li>
          </ul>
          <p>
            В случае принудительного изменения имени пользователя администрация уведомляет
            владельца аккаунта по указанному при регистрации адресу электронной почты не менее
            чем за 7 (семь) календарных дней до вступления изменений в силу, за исключением
            случаев мошенничества — тогда изменение может быть применено немедленно.
          </p>
          <p>
            Пользователь обязуется не регистрировать имена, имитирующие названия известных
            брендов, компаний, продуктов, государственных структур или публичных персон.
            Ряд таких имён зарезервирован Сервисом и недоступен для регистрации.
          </p>

          <h2 className="text-xl font-semibold mt-6">4. Контент пользователей</h2>
          <p>
            Вы сохраняете все права на созданный контент. Публикуя контент, вы даёте Сервису
            ограниченное право хранить, передавать и отображать его другим пользователям
            в рамках Сервиса.
          </p>
          <p>
            Администрация имеет право удалять контент, нарушающий правила, без предварительного
            уведомления.
          </p>

          <h2 className="text-xl font-semibold mt-6">5. Интеллектуальная собственность</h2>
          <p>
            Все элементы Сервиса, включая код, дизайн, логотипы и наименования, являются
            собственностью администрации Сервиса или используются на законных основаниях.
            Воспроизведение, копирование или распространение элементов Сервиса без письменного
            согласия запрещено.
          </p>

          <h2 className="text-xl font-semibold mt-6">6. Ограничение ответственности</h2>
          <p>
            Сервис предоставляется «как есть» (as is). Администрация не несёт ответственности за:
          </p>
          <ul className="list-disc list-inside space-y-1 text-surface-300">
            <li>Временную недоступность Сервиса</li>
            <li>Потерю данных в результате сбоев или действий третьих лиц</li>
            <li>Контент, публикуемый пользователями</li>
            <li>Упущенную выгоду или косвенные убытки</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6">7. Прекращение доступа</h2>
          <p>
            Администрация имеет право заблокировать или удалить аккаунт при нарушении
            настоящего Соглашения. При грубых или повторных нарушениях — без возможности
            восстановления и без предварительного уведомления.
          </p>

          <h2 className="text-xl font-semibold mt-6">8. Изменения Соглашения</h2>
          <p>
            Администрация вправе вносить изменения в Соглашение. Актуальная версия всегда
            доступна по адресу{' '}
            <Link to="/terms" className="text-brand-400 hover:text-brand-300">
              chat56.ru/terms
            </Link>
            . Продолжая использовать Сервис после публикации изменений, вы соглашаетесь
            с новой редакцией.
          </p>

          <h2 className="text-xl font-semibold mt-6">9. Применимое право</h2>
          <p>
            Настоящее Соглашение регулируется законодательством Российской Федерации.
            Все споры разрешаются путём переговоров, а при невозможности достижения согласия —
            в суде по месту нахождения администрации Сервиса.
          </p>

          <h2 className="text-xl font-semibold mt-6">10. Контакты</h2>
          <p>
            По вопросам, связанным с настоящим Соглашением:{' '}
            <a href="mailto:support@chat56.ru" className="text-brand-400 hover:text-brand-300">
              support@chat56.ru
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
